"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proveedorConverter = void 0;
const generarCampoBusqueda_1 = require("../utils/generarCampoBusqueda");
const proveedorConverter = {
    toFirestore(proveedor) {
        const obj = proveedor;
        if (obj.nombreComercial != null && obj.razonSocial != null && obj.documento != null) {
            obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({
                buscableParcialPor: [proveedor.nombreComercial, proveedor.razonSocial, proveedor.documento],
                buscableExactoPor: []
            });
        }
        else if (obj.nombreComercial != null && obj.razonSocial != null) {
            obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({
                buscableParcialPor: [proveedor.nombreComercial, proveedor.razonSocial],
                buscableExactoPor: []
            });
        }
        else if (obj.nombreComercial != null) {
            obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({ buscableParcialPor: [proveedor.nombreComercial], buscableExactoPor: [] });
        }
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            tipoDocumento: data.tipoDocumento,
            documento: data.documento,
            razonSocial: data.razonSocial,
            pais: data.pais,
            nombreComercial: data.nombreComercial,
            direccion: data.direccion,
            localidad: data.localidad,
            departamento: data.departamento,
            direccionEntrega: data.direccionEntrega,
            descuento: data.descuento,
            emails: data.emails,
            mailDgi: data.mailDgi,
            mailCopiaXml: data.mailCopiaXml,
            rubroCompraId: data.rubroCompraId,
            formaDePago: data.formaDePago,
            activo: data.activo,
            campoExtra: data.campoExtra ?? {},
            saldoCuentas: data.saldoCuentas ?? {},
            buscablePor: data.buscablePor,
            claveAnalisisDeuda: data.claveAnalisisDeuda ?? "",
            comentarios: data.comentarios
        };
    }
};
exports.proveedorConverter = proveedorConverter;
